import React from "react";

export const TOOLTIP_CONTENTS_LEGACY = <div className={'tip-content'}>
    <div className={'tip-title'}>
        <h4>Revenue Drivers</h4>
    </div>
    <div className={'tip-desc'}>
        <h5>Revenue</h5>
        <p>Shown revenue is your total net ad revenue, for the selected time period. Net revenue is your portion of revenue after the negotiated COOL Media portion of the revenue share.</p>
        <h5>Unit Load RPM</h5>
        <p>Unit Load RPM is the total revenue per thousand unit loads and is calculated by taking the total revenue, for the selected time period, and dividing it by the total number of unit loads, then multiplying by 1,000.</p>
        <h5>Unit Loads</h5>
        <p>Unit loads are the ad containers, both video and display, Insticator loads across each of your pages for all products including Full Ad Management, Commenting, and Trivia. For Commenting and Trivia, we count all ads associated with that product, regardless if it is a single ad or four ads, as a single until load.  For example, if we load one ad on the right rail, 2 ads on top of commenting, and another 2 ads at the bottom of commenting it would count as 2 unit loads.</p>
    </div>
</div>;

export const TOOLTIP_CONTENTS = <div className={'tip-content'}>
    <div className={'tip-title'}>
        <h4>Revenue Drivers</h4>
    </div>
    <div className={'tip-desc'}>
        <h5>Revenue</h5>
        <p>Shown revenue is your total net ad revenue, for the selected time period. Net revenue is your portion of revenue after the negotiated Insticator portion of the revenue share.</p>
        <h5>Monetizable Page Views</h5>
        <p>A “Monetizable Page View” is defined as the first insticator element loaded
            on a page EXCLUDING the header. The Monetizable Page Views report is a count
            of those page views for the selected time period. It excludes page views
            from bots, robots, crawlers or pages without advertisements.</p>
        <h5>Average RPM</h5>
        <p>Average RPM is the total net ad revenue per thousand monetizable page
            views and is calculated by taking the total net revenue, for the selected
            time period, and dividing it by the total monetizable page views, then
            multiplying by 1,000.</p>
    </div>
</div>;